import React, {useState} from 'react'
import styled from 'styled-components';
import { colours } from '../Styles';
import PackageBtns from './PackageBtns';
import {icons} from '../img/Icons';

function PackageCard(props) {
    const {downarrow} = icons;
    const {transpWhite, accent, light, transpDark} = colours;
    const PackageCard = styled.div`
    margin: 10px;
    height: fit-content;
    width: 500px;
    border-radius: 10px;
    background: ${transpWhite};
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    ////////////////////////////////
    .card-img {
    height: 200px;
    width: 100%;
    border-radius: 10px 10px 0 0;
    object-fit: cover;
    transition: 1s;
    }

    .card-bar {
    width: 100%;
    height: 30px;
    margin-top: 10px;
    background: ${accent};
    color: ${light};
    display: flex;
    align-items: center;
    justify-content: center;
    h4 {
        font-size: 15px;
    }
    }

    .card-description {
        margin: 15px;
        text-align: center;
        line-height: 25px;
    }

    .details-btn {
        cursor: pointer;
        margin-bottom: 15px;
        svg {
            width: 15px;
            height: 15px;
            animation: bounce 2s infinite;
        }
    }

    @keyframes bounce {
        50%{
            transform: translateY(5px);
        }
    }

    .option-list {
        list-style: none;
        width: 95%;
        li {
            padding: 5px 10px;
            :nth-child(2n) {
                background: ${light}
            }
        }
    }

    .package-name {
    width: 100%;
    height: 40px;
    // margin-top: 10px;
    font-size: 20px;
    font-family: "Play", sans-serif;
    color: ${light};
    // border-radius: 0 0 10px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-shadow: 1px 1px 5px ${transpDark};
    }

    #Gold {
        background-image: linear-gradient(315deg, #d99058 0%, #f8de7e 74%);
    }

    #Platinum {
        background-image: linear-gradient(315deg, #000000 0%, #414141 74%);
    }

    ///////////////////////////////
        @media only screen and (max-width: 600px) {
            width: 80%;
        }
    `;
    const optionList = props.options.map((item) => <li>{item}</li>)

    const [optionsVisible, setOptionsVisible] = useState(false);

    function ToggleOptions() {
      setOptionsVisible(optionsVisible ? false : true);
    }
        
    return (
        <PackageCard>
            <img className="card-img" src={props.imgsrc} alt={props.imgalt} />
            {/* <div className="card-bar"><h4>{props.barText}</h4></div> */}
            <div className="package-name" id={props.name}>{props.name}</div>
            <p className="card-description">{props.description}</p>
            {optionsVisible ?
            <>
                <h4 className="details-btn" onClick={() => ToggleOptions()}>- hide details -</h4> 
                <ul className="option-list">
                {optionList}
                </ul>
            </>
            : 
            <h4 className="details-btn" onClick={() => ToggleOptions()}>{downarrow} show details {downarrow}</h4>}
            <PackageBtns />
            <div className="card-bar"><h4>{props.barText}</h4></div>
            {/* <div className="package-name" id={props.name}>{props.name}</div> */}
        </PackageCard>
    )
}

export default PackageCard;